// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group .list-group-item {
  background-color: transparent;
  border: none;
}

.progress {
  background-color: transparent;
}

h6 {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: var(--theme-main-color, #055C8D);
  padding-left: 10px;
}

.status {
  color: #000;
}

.status:hover {
  background-color: #f3f3f3;
}

.status {
  cursor: pointer;
}

.value {
  width: 8%;
}

.graph {
  width: 92%;
}

.no-data {
  font-size: 11px;
  color: #859296;
  text-align: center;
  height: 50px;
}

.medium-loader {
  border: 1px solid #f3f3f3;
  border-radius: 50%;
  border-top: 1px solid #3498db;
  width: 30px;
  height: 30px; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.show-loader {
  height: 50px;
  background-color: white;
}

.progress [_ngcontent-chh-c351] {
  --bs-progress-bar-bg: var(--theme-main-background-color, #055C8D) !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
